module.exports = __webpack_public_path__ + "static/media/home-header.57bd2a50.svg";